module.exports = __webpack_public_path__ + "static/media/masw.f6aeca7f.png";